<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>NUEVO TIPO EVENTO</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-grid v-if="cargando || cargandoPrioridades || cargandoEmpresas || cargandoTiposUsuario" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list v-else>
      <ion-item>
        <ion-label position="floating">NOMBRE TIPO EVENTO</ion-label>
        <ion-input class="text-uppercase" v-model="tipoEvento.nombre"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">PRIORIDAD</ion-label>
        <ion-select placeholder="SELECCIONA UNO" v-model="tipoEvento.prioridad" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="prioridad in prioridades" :key="prioridad.pri_id+'pri'" :value="prioridad.pri_id">{{prioridad.pri_prioridad}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">EMPRESA</ion-label>
        <ion-select :disabled="padre!=null" placeholder="SELECCIONA UNO" v-model="tipoEvento.empresa" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="empresa in empresas" :key="empresa.emp_id+'emp'" :value="empresa.emp_id">{{empresa.emp_nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">REPORTAR A (TIPOS USUARIO)</ion-label>
        <ion-select placeholder="SELECCIONA AL MENOS UNO" multiple="true" v-model="tipoEvento.tiposUsuario" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="tipo in tiposUsuario" :key="tipo.tpu_id+'tpu'" :value="tipo.tpu_id">{{tipo.tpu_nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">REPORTAR A (TURNOS)</ion-label>
        <ion-select placeholder="SELECCIONA AL MENOS UNO" multiple="true" v-model="tipoEvento.turnos" cancel-text="CANCELAR" ok-text="ACEPTAR">
          <ion-select-option v-for="turno in turnos" :key="turno.trn_id+'trn'" :value="turno.trn_id">{{turno.trn_nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
  </ion-content>

  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col>
            <ion-button @click="cerrarModal()" color="danger" shape="round" expand="block">
                <ion-label>CERRAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button :disabled="!validaDatos()" @click="registrarTipoEvento();" color="success" shape="round" expand="block">
                <ion-label>REGISTRAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { modalController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, 
      IonLabel, IonItem, IonInput, IonSpinner, IonList, IonSelect, IonSelectOption, toastController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { addIcons        } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline } from 'ionicons/icons';
import { Preferences     } from '@capacitor/preferences';
import { cerrarSesion    } from '@/plugins/funciones.ts';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';

export default defineComponent({
  name: 'ModalNuevoTipoEvento',
  props: {
    modal   : Object,
    padre   : Object
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel, 
  IonItem, IonInput, IonSpinner, IonList, IonSelect, IonSelectOption },
  data(){
    return {
      cargando              : false,
      cargandoPrioridades   : false,
      cargandoEmpresas      : false,
      cargandoTiposUsuario  : false,
      tipoEvento            : {nombre:'', prioridad:'', empresa:'', tiposUsuario:[], padre:'', turnos:[]},
      prioridades           : [],
      empresas              : [],
      tiposUsuario          : [],
      turnos                : []
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
  },
  mounted(){
    this.listarPrioridades();
    this.listarEmpresas();
    this.listarTurnos();
    this.listarTiposUsuarioPorEmpresa();
    if(this.padre != null){
      this.tipoEvento.padre   = this.padre.tev_id;
      this.tipoEvento.empresa = this.padre.tev_empresa;
    }else{
      this.tipoEvento.padre   = null;
    }
  },
  methods:{
    async listarTurnos(){
      this.cargandoTurnos  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/administrador/listarTurnos', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargandoTurnos = false;
        this.turnos = resp.data.turnos;
      }).catch(() =>{
        this.cargandoTurnos = false;
        this.muestraToast('ERROR AL OBTENER PRIORIDADES.');
      });
    },

    async listarPrioridades(){
      this.cargandoPrioridades  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/administrador/listarPrioridades', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargandoPrioridades = false;
        this.prioridades = resp.data.prioridades;
      }).catch(() =>{
        this.cargandoPrioridades = false;
        this.muestraToast('ERROR AL OBTENER CARGOS.');
      });
    },

    async listarEmpresas(){
      this.cargandoEmpresas  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/administrador/listarEmpresasPorRut', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargandoEmpresas = false;
        this.empresas = resp.data.empresas;
        if(this.empresas.length == 1){
          this.tipoEvento.empresa = this.empresas[0].emp_id;
        }
      }).catch(()=>{
        this.cargandoEmpresas = false;
        this.muestraToast('ERROR AL OBTENER CARGOS.');
      });
    },

    async listarTiposUsuarioPorEmpresa(){
      this.cargandoTiposUsuario     = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      const dato                = new URLSearchParams();
      dato.append('id_empresa', 1);
      axios.post(rutaBase+'/administrador/listarTiposUsuarioPorEmpresa', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargandoTiposUsuario = false;
        this.tiposUsuario = resp.data.tiposUsuario;
      }).catch(()=>{
        this.cargandoTiposUsuario = false;
        this.muestraToast('ERROR AL OBTENER CARGOS.');
      });
    },

    async registrarTipoEvento(){
      this.cargando  = true;
      const token               = await Preferences.get({ key: 'token_auth' });
      const headers             = { headers: { 'Authorization': `${token.value}` } };
      const dato                = new URLSearchParams();
      dato.append('tipo_evento', JSON.stringify(this.tipoEvento));
      axios.post(rutaBase+'/administrador/registrarTipoEvento', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargando = false;
        if(resp.data.key == 1){
          this.muestraToast('DATOS REGISTRADOS CORRECTAMENTE.');
          this.cerrarModal({recargar:true});
        }
        else{
          this.muestraToast('A OCURRIDO UN ERROR.');
        }
      }).catch(()=>{
        this.cargando = false;
        this.muestraToast('ERROR AL REGISTRAR DATOS.');
      });
    },

    validaDatos(){
      if(
        this.tipoEvento.nombre              == '' ||
        this.tipoEvento.prioridad           == '' ||
        this.tipoEvento.empresa             == '' ||
        this.tipoEvento.tiposUsuario.length == 0
      ){
        return false;
      }
      else {
        return true;
      }
    },

    async cerrarModal(dato=null){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>

<style>
.alert-wrapper.sc-ion-alert-md {
  min-width:350px !important;
  max-width:none !important;
}
</style>